import { TicketOverviewController as controller } from './ticketOverview.controller';
import template from './ticketOverview.html';

export const ticketOverviewComponent = {
  name: 'ticketOverviewComponent',
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    tickets: '<',
    ticketsType: '<'
  }
};
